import {Component} from 'react';
import {withRouter} from 'react-router-dom';


class ScrollToTop extends Component {

    constructor(props)
    {
        super(props);
        this.state = {
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot)
    {
        if (this.props.location !== prevProps.location) {
            window.scrollTo(0, 0)
        }
    }

    render() {
        return false;
    }

}

export default withRouter(ScrollToTop)
